import React, {useContext, useEffect, useState} from "react";
import styled from "styled-components";
import {ButtonWidget} from "../../../widget/pub/button_widget";
import {ClaimsListCell} from "../../../interface/claims/claims_list_cell";
import {Skeleton} from "@material-ui/lab";
import {HttpStatus, useWait} from "../../../utils/wait_fn";
import {useClaimApply} from "../fn/use_claim_apply";
import {SuccessWidget} from "../../personal/arbitration/success_widget";
import {ClaimsProvider} from "./index";
import {useHistory} from "react-router-dom";
import {StatusWidget} from "../widget/status";
import {DateUtils} from "../../../utils/date";
import {useSendModal} from "../../../model/http_loading";
import {formatAddress} from "../../../utils/formatBalance";
import {PageInatWidegt} from "../../../widget/pub/paginat_widget";
import {HttpServer} from "../../../net/http_server";
import {checkFn, StatusEnum} from "../../../utils/status_check";


export const MainWidget: React.FC = () => {
    const [page,setPage] = useState(1);

    const {request, data, status} = useWait<any>(HttpServer.claimListNew);
    const {setTopData} = useContext(ClaimsProvider)
    const history = useHistory();

    useEffect(() => {
        request(page)
    }, [page])

    useEffect(() => {
        if (data != null)
            setTopData(data);
    }, [data])

    return (
        <div>
            <WapStyle>
                <div className={'bar padding'}>
                    <div>Claim ID</div>
                    <div>CLAIM BY</div>
                    <div>Submitted</div>
                    <div>Product</div>
                    <div>State</div>
                    {/*<div>Assessors/total</div>*/}
                    <div>Action</div>
                </div>
                <div className={'main'}>
                    {
                        status === HttpStatus.success ?
                            data?.claim_list ? data?.claim_list.map((ev: any, i: number) => <CellWidget
                                key={'iddasd' + i} bg={i % 2 !== 0}
                                onClick={() => history.push('/claims/msgpage/' + ev.claim_id)}
                                model={ev}/>) : <NullStyle>N/A</NullStyle> :
                            [0, 0, 0, 0, 0, 0].map((ev, i) => <LoadingWidget key={'iddasd' + i} bg={i % 2 !== 0}/>)
                    }
                </div>
                <PageInatWidegt setPage={setPage} total={data?.total}/>
            </WapStyle>
        </div>
    );
}

const CellWidget: React.FC<{ bg: boolean, model: ClaimsListCell, onClick: Function }> = ({bg, model, onClick}) => {
    const applyFn = useClaimApply(model.claim_id, model.product);
    const [status, setStaus] = useState(model.status);
    const load = useSendModal(async () => {
        let _data = await applyFn();
        setStaus(_data);
    }, SuccessWidget);


    return (
        <CellStyle bg={bg} className={'padding cell'} onClick={() => onClick()}>
            <div>{model.claim_id}</div>
            <div>{formatAddress(model.user_id)}</div>
            <div>{DateUtils.dataString(model.submit_at)}</div>
            <div>{model.product}</div>
            <div><StatusWidget status={status}/></div>
            <div>

                <ButtonWidget bgColor={'#0064FD'}
                              onClick={load}
                              text={'Apply'}
                              disable={!checkFn(StatusEnum.new, model?.status)}
                              size={{x: 7, y: 25}}/>
            </div>
        </CellStyle>
    );
}


export const NullStyle = styled.div`
  padding: 20px;
  text-align: center;
`

export const LoadingWidget: React.FC<{ bg: boolean, }> = ({bg,}) => {
    return (
        <CellStyle bg={bg} className={'padding cell'}>
            <div><Skeleton variant="text" height={20}/></div>
        </CellStyle>
    );
}


export const WapStyle = styled.div`

  .padding {
    display: flex;
    justify-content: center;
    padding: 0 20px;
    box-sizing: border-box;
    align-items: center;

    div {
      flex: 1;
    }

    //div:nth-child(1){
    //  text-align: left;
    //}
    //div:nth-child(2){
    //  flex: 1;
    //
    //}
    //div:nth-child(3){
    //  flex: 3;
    //}
    //div{
    //  text-align: right;
    //}
  }

  .bar {
    background-color: #F7F9FC;
    height: 60px;
    color: #555;
    box-shadow: 0px 9px 10px 0px rgba(0, 0, 0, 0.06);
  }

  .cell {
    padding-top: 20px;
    padding-bottom: 20px;

  }

`

export const CellStyle = styled.div<{ bg: boolean }>`
  //border-bottom: 1px solid #D5D5D5;
  background-color: ${({bg}) => bg ? '#F7F9FC' : '#fff'};

  div {
    font-size: 16px;
    font-weight: 400;
    color: #666666;

    &:last-child {
      color: white;
    }
  }
`
